import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgErrorOutlined = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 3.5C7.65625 3.5 5.53125 4.75 4.34375 6.75C3.1875 8.78125 3.1875 11.25 4.34375 13.25C5.53125 15.2812 7.65625 16.5 10 16.5C12.3125 16.5 14.4375 15.2812 15.625 13.25C16.7812 11.25 16.7812 8.78125 15.625 6.75C14.4375 4.75 12.3125 3.5 10 3.5ZM10 18C7.125 18 4.5 16.5 3.0625 14C1.625 11.5312 1.625 8.5 3.0625 6C4.5 3.53125 7.125 2 10 2C12.8438 2 15.4688 3.53125 16.9062 6C18.3438 8.5 18.3438 11.5312 16.9062 14C15.4688 16.5 12.8438 18 10 18ZM7.46875 7.46875C7.75 7.1875 8.21875 7.1875 8.5 7.46875L9.96875 8.9375L11.4375 7.46875C11.75 7.1875 12.2188 7.1875 12.5 7.46875C12.8125 7.78125 12.8125 8.25 12.5 8.53125L11.0313 10L12.5 11.4687C12.8125 11.7812 12.8125 12.25 12.5 12.5312C12.2188 12.8437 11.75 12.8437 11.4375 12.5312L9.96875 11.0625L8.5 12.5312C8.21875 12.8437 7.75 12.8437 7.46875 12.5312C7.15625 12.25 7.15625 11.7812 7.46875 11.4688L8.9375 10L7.46875 8.53125C7.15625 8.25 7.15625 7.78125 7.46875 7.46875Z"
	})
});
const ForwardRef = forwardRef(SvgErrorOutlined);
export default ForwardRef;
